// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bdJq","tabsBox":"styles_tabsBox__3dBJr","createButton":"styles_createButton__1HHox"};